<div class="hidden sm:block mb-6">
  <nav class="flex space-x-4" aria-label="Tabs">
    <a routerLink="/settings/account"
       [class.bg-gray-200]="selectedTab === '/settings/account'"
       [class.text-gray-800]="selectedTab === '/settings/account'"
       [attr.aria-current]="selectedTab === '/settings/account' ? 'page' : null"
       class="rounded-md px-3 py-2 text-sm font-medium"
       [ngClass]="selectedTab !== '/settings/account' ? 'text-secondary hover:opacity-90' : 'text-violet-500 bg-violet-50'">
      Account Settings
    </a>

    <a routerLink="/settings/profile"
       [class.bg-gray-200]="selectedTab === '/settings/profile'"
       [class.text-gray-800]="selectedTab === '/settings/profile'"
       [attr.aria-current]="selectedTab === '/settings/profile' ? 'page' : null"
       class="rounded-md px-3 py-2 text-sm font-medium"
       [ngClass]="selectedTab !== '/settings/profile' ? 'text-secondary hover:opacity-90' : 'text-violet-500 bg-violet-50'">
      Update Profile
    </a>

    <a routerLink="/settings/billing-profile"
       [class.bg-gray-200]="selectedTab === '/settings/billing-profile'"
       [class.text-gray-800]="selectedTab === '/settings/billing-profile'"
       [attr.aria-current]="selectedTab === '/settings/billing-profile' ? 'page' : null"
       class="rounded-md px-3 py-2 text-sm font-medium"
       [ngClass]="selectedTab !== '/settings/billing-profile' ? 'text-secondary hover:opacity-90' : 'text-violet-500 bg-violet-50'">
      Company Billing
    </a>

    <a routerLink="/settings/invoices"
       [class.bg-gray-200]="selectedTab === '/settings/invoices'"
       [class.text-gray-800]="selectedTab === '/settings/invoices'"
       [attr.aria-current]="selectedTab === '/settings/invoices' ? 'page' : null"
       class="rounded-md px-3 py-2 text-sm font-medium"
       [ngClass]="selectedTab !== '/settings/invoices' ? 'text-secondary hover:opacity-90' : 'text-violet-500 bg-violet-50'">
      Invoices
    </a>
  </nav>
</div>

<div class="md:hidden mb-6">
  <label for="tabs" class="sr-only">Select a tab</label>
  <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
  <select id="tabs" name="tabs" (change)="onTabChange($event)" [(ngModel)]="selectedTab" class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
    <option value="/settings/account">Account</option>
    <option value="/settings/profile">Update Profile</option>
    <option value="/settings/billing-profile">Company Billing</option>
    <option value="/settings/invoices">Invoices</option>
    <option value="manage-subscription">Manage Subscription</option>
  </select>
</div>
